import React, { Component } from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';

class CommonTokenExpired extends Component {

    render() {
        const { Token, onLogout } = this.props;

        if (!Token?.Expired) return null; 

        return (
            <Modal
                show={true}
                size="md"             
                centered
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header>
                    <Modal.Title className="text-danger fs-6">
                        <i className="fa fa-exclamation-triangle me-2" />
                        ระยะเวลาการเข้าใช้ระบบหมดอายุ
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Alert variant="warning" className="mb-0 fs-7">
                         <i className="fa-classic fa-light fa-right-to-bracket fa-fw me-2"></i>กรุณาเข้าสู่ระบบอีกครั้งเพื่อใช้งาน
                    </Alert>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="warning" 
                        size="sm" 
                        as={Link}
                        to="/logout">
                        <i className="fa-classic fa-light fa-power-off fa-fw me-2"></i>ออกจากระบบ
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default CommonTokenExpired;
